import { CircularProgress } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { FormikAutocomplete } from "@poseidon/ui/components/form/FormikAutocomplete";
import { Field } from "formik";
import { useNationalities } from "../../hooks/useNationalities";
import { useEffect } from "react";

export const NationalitiesField = ({ label, name }) => {
  const { nationalities, loading, error } = useNationalities();
  const { setError } = useErrorMessage();
  useEffect(() => {
    if (error) {
      setError(error);
    }
  }, [setError, error]);

  if (loading) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }

  return (
    <Field
      component={FormikAutocomplete}
      fullWidth={true}
      label={label}
      name={name}
      options={nationalities}
      margin="none"
    />
  );
};
